import type { IOption } from './IOption'

import type { IPropertyFilter } from './IPropertyFilter'
import { formatODataDate } from '@sales-center/common'

import { addDays, endOfToday, startOfToday } from 'date-fns/esm'

export type LimitedDate = IOption | null

export const isValidLimitedDate = (value: LimitedDate) => value !== null

export interface ILimitedDateFilter<T> extends IPropertyFilter<T> {
  type: 'limitedDate'
  value: LimitedDate
}

export const isLimitedDateFilter = <T>(
  filter: IPropertyFilter<T>,
): filter is ILimitedDateFilter<T> => filter.type === 'limitedDate'

export function normalizeLimitedDateFilter<T>(
  filter: ILimitedDateFilter<T>,
): string {
  const { propertyName, value } = filter
  if (value === null) return ''

  const days = Number(value.value)

  const propertyNameStr = String(propertyName)

  const startTimeLocal = addDays(startOfToday(), days)
  const startTimeUTC = new Date(
    startTimeLocal.getTime() + startTimeLocal.getTimezoneOffset() * 60000,
  )
  const startTimeUTCFormatted = formatODataDate(startTimeUTC)

  const endTimeLocal = endOfToday()
  const endTimeUTC = new Date(
    endTimeLocal.getTime() + endTimeLocal.getTimezoneOffset() * 60000,
  )
  const endTimeUTCFormatted = formatODataDate(endTimeUTC)

  const comp1 = days < 1 ? 'ge' : 'le'
  const comp2 = days < 1 ? 'le' : 'ge'

  return `(${propertyNameStr} ${comp1} ${startTimeUTCFormatted} and ${propertyNameStr} ${comp2} ${endTimeUTCFormatted})`
}
